module.exports = __webpack_public_path__ + "static/media/favicon.44f5f540.png";